import { useQuery } from 'react-query';

import axios from './axios';
import { downloadFileFromBlob } from 'src/utils/downloadFile';

export function useDownloadUsersListExcel() {
  return useQuery(
    'download-users-list-excel',
    async () =>
      axios.get('/posht/ashena/users/export/').then((response) => {
        downloadFileFromBlob(response.data, 'users.csv');
      }),
    {
      enabled: false,
      cacheTime: 0,
      suspense: false,
    },
  );
}
